import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialColumns, initialFilter } from "./StudentReportUIHelpers";

const StudentReportUIContext = createContext();

export function useStudentReportUIContext() {
  return useContext(StudentReportUIContext);
}

export const StudentReportUIConsumer = StudentReportUIContext.Consumer;

export function StudentReportUIProvider({ children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [columns, setColumns] = useState(initialColumns);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    columns,
    setColumns,
    setQueryParams
  };

  return (
    <StudentReportUIContext.Provider value={value}>
      {children}
    </StudentReportUIContext.Provider>
  );
}